import AbbreviationSetupAPI from '@/api/AbbreviationSetupAPI.js';
import httpClient from '../../api/axios-httpclient';
import commonFunc from '@/common/commonFunction';

export default {
	/**
	 * Lấy thông tin thiết lập
	 */
	loadAbbreviationSetups: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: AbbreviationSetupAPI.getAPIUrlSubParam(commonFunc.getSubParam()),
				params: payload
			},
			true
		);

		if (!res || !res.Success || !res.Data || res.Data.length <= 0) return null;
		context.commit('updateAbbreviationSetups', res.Data);
		return res.Data;
	},

	/**
	 * Lấy thông tin thiết lập mặc định
	 */
	loadDefaultAbbreviationSetups: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: `${AbbreviationSetupAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/default`,
				params: payload
			},
			true
		);

		if (!res || !res.Success || !res.Data || res.Data.length <= 0) return null;

		// Map lại ID cũ nếu có để đảm bảo khi lưu không bị lỗi trùng hoặc tạo mới không mong muốn
		const currentSetups = context.state.AbbreviationSetups;
		if (currentSetups && currentSetups.length > 0) {
			res.Data.forEach(defaultItem => {
				const existingItem = currentSetups.find(x => x.Abbreviation === defaultItem.Abbreviation);
				if (existingItem) {
					defaultItem.Id = existingItem.Id;
				}
			});
		}

		context.commit('updateAbbreviationSetups', res.Data);
		return res.Data;
	},

	saveAbbreviationSetups: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: `${AbbreviationSetupAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/save`,
				data: payload
			},
			true
		);

		if (!res || !res.Success || !res.Data) return false;
		context.commit('updateAbbreviationSetups', payload.abbreviationSetups);
		return res.Success;
	}
};
